const initialState = {
  pos: [
    { label: "桃園火車站", pos: [24.989091044191944, 121.31445629500928] },
    { label: "桃園藝文廣場", pos: [25.01748496655275, 121.29998728728835] },
  ],
  time: {
    type: "出發時間",
    date: "12/31(五)",
    clock: "14:00",
  },
  planlist: [
    {
      plan: [
        { label: "桃園火車站", pos: [24.989091044191944, 121.31445629500928] },
        { label: "桃園藝文廣場", pos: [25.01748496655275, 121.29998728728835] },
      ],
      time: ["14:00", "14:23", "23"],
      step: [
        {
          type: "walk",
          time: "5",
          start: {
            label: "桃園火車站",
            pos: [24.989091044191944, 121.31445629500928],
          },
          end: {
            label: "統領百貨站",
            pos: [24.989091044191944, 121.31445629500928],
          },
          routePos: [
            [24.989091044191944, 121.31445629500928],
            [24.989115086895946, 121.3141771888349],
            [24.98933802708092, 121.31365190611362],
            [24.98938714944021, 121.31324752179641],
            [24.989383370797896, 121.31323918397544],
            [24.989621425037548, 121.31314329903424],
            [24.989826512973217, 121.31324669506273],
            [24.991465068934517, 121.31261905815762],
            [24.991309479991305, 121.31207188752654],
            [24.991217098963084, 121.31210943845218],
          ],
        },
        {
          city: "Taoyuan",
          type: "bus",
          name: "152",
          start: {
            label: "統領百貨",
            pos: [24.991228150817925, 121.31209634112956],
          },
          end: {
            label: "大興西新埔六街口",
            pos: [25.01316338984515, 121.30233662899018],
          },
          routePos: [
            [24.991228150817925, 121.31209634112956],
            [24.991307006357626, 121.31206999014942],
            [24.991487149817715, 121.312617846519],
            [24.992641901373453, 121.3121803707652],
            [24.99307312049156, 121.31206709219246],
            [24.99330146080474, 121.31196988010089],
            [24.994051187215604, 121.31143309359689],
            [24.99458714365687, 121.31110139619662],
            [24.994661812562594, 121.31124556892519],
            [24.99533281821007, 121.31083483118425],
            [24.995331884855663, 121.31083277157414],
            [24.995271216706332, 121.31068653923457],
            [24.99878434933851, 121.30849971051725],
            [24.999326259200963, 121.30813546694817],
            [24.99932236075662, 121.3081337433785],
            [25.000237357845016, 121.30751765710286],
            [25.000885191581002, 121.30713812452709],
            [25.002595912669225, 121.30602134208331],
            [25.002689500575027, 121.30600927214267],
            [25.002689500575027, 121.30600927214267],
            [25.00278065755833, 121.30594087581252],
            [25.00344306291226, 121.30557475428219],
            [25.003922486344756, 121.30524364777825],
            [25.005675550381294, 121.30415858653285],
            [25.006610718000477, 121.30356696768295],
            [25.007584068755257, 121.3029442721852],
            [25.008373449039922, 121.30248995237686],
            [25.009438521177003, 121.30192710630595],
            [25.010259223069603, 121.30146659550445],
            [25.010640557198737, 121.30121263178663],
            [25.01208998050044, 121.30046807092472],
            [25.01227349576899, 121.30039565128145],
            [25.012293215358646, 121.30039470983183],
            [25.01316338984515, 121.30233662899018],
          ],
        },
        {
          type: "walk",
          time: "7",
          start: {
            label: "大興西新埔六街口",
            pos: [25.01316338984515, 121.30233662899018],
          },
          end: {
            label: "桃園藝文廣場",
            pos: [25.01748496655275, 121.29998728728835],
          },
          routePos: [
            [25.01316338984515, 121.30233662899018],
            [25.013484234773696, 121.30300181684123],
            [25.017100973868647, 121.30121010137469],
            [25.016819027606772, 121.30029815038873],
            [25.0174734381007, 121.3000109115323],
          ],
        },
      ],
      price: 18,
    },
    {
      plan: [
        { label: "桃園火車站", pos: [24.989091044191944, 121.31445629500928] },
        { label: "桃園藝文廣場", pos: [25.01748496655275, 121.29998728728835] },
      ],
      time: ["14:05", "14:26", "21"],
      step: [
        {
          type: "walk",
          time: "5",
          start: {
            label: "桃園火車站",
            pos: [24.989091044191944, 121.31445629500928],
          },
          end: {
            label: "統領百貨站",
            pos: [24.989091044191944, 121.31445629500928],
          },
          routePos: [
            [24.989091044191944, 121.31445629500928],
            [24.989115086895946, 121.3141771888349],
            [24.98933802708092, 121.31365190611362],
            [24.98938714944021, 121.31324752179641],
            [24.989383370797896, 121.31323918397544],
            [24.989621425037548, 121.31314329903424],
            [24.989826512973217, 121.31324669506273],
            [24.991465068934517, 121.31261905815762],
            [24.991309479991305, 121.31207188752654],
            [24.991217098963084, 121.31210943845218],
          ],
        },
        {
          city: "Taoyuan",
          type: "bus",
          name: "151",
          start: {
            label: "統領百貨",
            pos: [24.991228150817925, 121.31209634112956],
          },
          end: {
            label: "中正藝文特區(福安宮)",
            pos: [25.01471075852239, 121.29933373310487],
          },
          routePos: [
            [24.991228150817925, 121.31209634112956],
            [24.991307006357626, 121.31206999014942],
            [24.991487149817715, 121.312617846519],
            [24.992641901373453, 121.3121803707652],
            [24.99307312049156, 121.31206709219246],
            [24.99330146080474, 121.31196988010089],
            [24.994051187215604, 121.31143309359689],
            [24.99458714365687, 121.31110139619662],
            [24.994661812562594, 121.31124556892519],
            [24.99533281821007, 121.31083483118425],
            [24.995331884855663, 121.31083277157414],
            [24.995271216706332, 121.31068653923457],
            [24.99878434933851, 121.30849971051725],
            [24.999326259200963, 121.30813546694817],
            [24.99932236075662, 121.3081337433785],
            [25.000237357845016, 121.30751765710286],
            [25.000885191581002, 121.30713812452709],
            [25.002595912669225, 121.30602134208331],
            [25.002689500575027, 121.30600927214267],
            [25.002689500575027, 121.30600927214267],
            [25.00278065755833, 121.30594087581252],
            [25.00344306291226, 121.30557475428219],
            [25.003922486344756, 121.30524364777825],
            [25.005675550381294, 121.30415858653285],
            [25.006610718000477, 121.30356696768295],
            [25.007584068755257, 121.3029442721852],
            [25.008373449039922, 121.30248995237686],
            [25.009438521177003, 121.30192710630595],
            [25.010259223069603, 121.30146659550445],
            [25.010640557198737, 121.30121263178663],
            [25.01208998050044, 121.30046807092472],
            [25.01227349576899, 121.30039565128145],
            [25.0142589873279, 121.29943493357537],
            [25.014673666365567, 121.299237795675],
            [25.01471498683883, 121.29932630857233],
          ],
        },
        {
          type: "walk",
          time: "7",
          start: {
            label: "大興西新埔六街口",
            pos: [25.01471075852239, 121.29933373310487],
          },
          end: {
            label: "桃園藝文廣場",
            pos: [25.01748496655275, 121.29998728728835],
          },
          routePos: [
            [25.01470324081139, 121.2993335154357],
            [25.014673634117113, 121.2992355015957],
            [25.016082058950893, 121.2986334165785],
            [25.016754544398303, 121.30029031720761],
            [25.017135242486418, 121.30020510218314],
            [25.0174734381007, 121.3000109115323],
          ],
        },
      ],
      price: 18,
    },
  ],
};

// {
//   time: [startTime, endTime, costTime],
//   step: [
//     { type: "walk", time: "2" },
//     { type: "bus", name: "568" },
//   ],
//   price: 15,
// };

export const planReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
